import { createSelector } from 'reselect'
import { IRootState } from '../reducer'

export const prefix = 'presence'

export const onlineUserIds = (state: IRootState) => state[prefix].onlineUserIds

/**
 * Live nickname/status edits pushed over `AIM_PROFILE_CHANGED`, keyed by user id.
 *
 * Sparse and an *overlay*, not a roster: the authoritative name and status still
 * arrive pre-resolved on each server payload, and this holds only the people who
 * have changed something since this tab loaded. Consumers merge it over whatever
 * they already render — see `MembersPanel`.
 *
 * Returned raw on purpose. Expiry is deliberately NOT applied here: a reselect
 * selector memoizes on an unchanged input object, so it could never turn a live
 * status into an expired one however often it is read. Callers apply
 * `liveAimStatus` against a `useAimStatusTick`.
 */
export const aimProfileByUserId = (state: IRootState) => state[prefix].profileByUserId

/** Everyone in a huddle right now, for the headphones beside their names. */
export const huddleUserIds = createSelector(
  (state: IRootState) => state[prefix].inHuddleUserIds,
  (userIds) => new Set(userIds),
)
